import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Proximity "happy page" empty state. Shown in place of an empty grid when a list
 * has no records, per Proximity UI standards.
 *
 * Project the page-specific illustration as default content; pass the heading and
 * message as inputs. Optionally project an action (e.g. a button) into the [actions] slot:
 *
 *   <prox-empty-state heading="Hello, Dana!" [message]="..">
 *     <svg ...>...</svg>
 *     <p-button actions label="..." (onClick)="..."></p-button>
 *   </prox-empty-state>
 */
@Component({
  selector: 'prox-empty-state',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-start py-12 px-8">
      <div class="qb-detail-card qb-primary-tint flex flex-row items-center gap-10 px-12 py-12" style="max-width: 720px;">
        <div class="shrink-0">
          <ng-content></ng-content>
        </div>
        <div>
          <h3 class="text-3xl font-semibold mb-3" style="color: var(--p-text-color);">{{ heading }}</h3>
          <p class="text-lg leading-relaxed" style="color: var(--p-text-muted-color);">{{ message }}</p>
          <ng-content select="[actions]"></ng-content>
        </div>
      </div>
    </div>
  `,
})
export class EmptyStateComponent {
  /** Friendly heading, e.g. "Hello, Dana!" */
  @Input() heading = '';
  /** Context-sensitive body message explaining why the list is empty. */
  @Input() message = '';
}
